export default __webpack_public_path__ + "static/media/par-1.5209071b.png";